// extracted by mini-css-extract-plugin
export default {"container":"FzV4j_WLJInmIKGStrXy","progress":"wZHX1IUawjgnnZ2j9uVb","ring":"wAS3Oe9_PHpwaV_KFbji","under25":"PJYwSU7D0efJ1EidwF3u","under50":"JM50yyBqOMEZ7LNUB5jw"};